// AI Generated Pipe
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'wcagClass',
    standalone: false,
})
export class WcagClassPipe implements PipeTransform {
    transform (input: string): string {
        if (!input) {
            return '';
        }

        if (input === 'A') {
            return 'wcag-a';
        } else if (input === 'AA') {
            return 'wcag-aa';
        } else if (input === 'AAA') {
            return 'wcag-aaa';
        }

        return '';
    }
}
